<template>
  <f7-page :no-swipeback="true" ptr @ptr:refresh="refreshData" @page:reinit="getList">
    <f7-navbar :no-shadow="true">
      <f7-nav-title class="nav-title">
        <form
          class="searchbar searchbar-home"
          id="searchbar-home"
          @searchbar:search="searchProjectList">
          <div class="searchbar-inner">
            <div class="searchbar-input-wrap">
              <input type="search" placeholder="工程名称">
              <i class="searchbar-icon"></i>
              <span class="input-clear-button"></span>
            </div>
            <span class="searchbar-disable-button searchbar-button-home">取消</span>
          </div>
        </form>
      </f7-nav-title>
      <f7-nav-right>
        <f7-link
          icon="cicon-caozuo"
          class="navbar-menu"
          @click="editableList"
          style="margin-left: 0em;">
        </f7-link>
        <f7-link
          href="/notice/list"
          class="navbar-menu"
          style="margin-left: 0em;">
          <f7-icon fa="bell-o">
            <f7-badge color="red" v-if="msgStatus.unReadInviteMsgNum > 0">
              {{ msgStatus.unReadInviteMsgNum }}
            </f7-badge>
          </f7-icon>
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content-margin quick-menu">
      <div style="padding: 0rem 1rem;">
        <f7-swiper :params="{slidesPerView: 4, spaceBetween: 10,
          observer: true, observeParents: true}">
          <f7-swiper-slide>
            <div class="quick-menu-link">
              <f7-link @click="callWorkMsg">
                <div>
                  <div>
                    <img width="100%" height="100%" src="@/assets/img/gongzuoxiaoxi.png" />
                  </div>
                  <div class="quick-menu-text">工作消息</div>
                </div>
              </f7-link>
            </div>
          </f7-swiper-slide>
          <f7-swiper-slide>
            <div class="quick-menu-link">
              <f7-link @click="callAttendance">
                <div>
                  <div>
                    <img width="100%" height="100%" src="@/assets/img/shimingkaoqin.png" />
                  </div>
                  <div class="quick-menu-text">实名考勤</div>
                </div>
              </f7-link>
            </div>
          </f7-swiper-slide>
          <f7-swiper-slide>
            <div class="quick-menu-link">
              <f7-link @click="projectPopupOpened = true">
                <div>
                  <div>
                    <img width="100%" height="100%" src="@/assets/img/shigongrizhi.png" />
                  </div>
                  <div class="quick-menu-text">施工日志</div>
                </div>
              </f7-link>
            </div>
          </f7-swiper-slide>
          <f7-swiper-slide>
            <div class="quick-menu-link">
              <f7-link href="/report/index">
                <div>
                  <div>
                    <img width="100%" height="100%" src="@/assets/img/zhinengbaobiao.png"/>
                  </div>
                  <div class="quick-menu-text">智能报表</div>
                </div>
              </f7-link>
            </div>
          </f7-swiper-slide>
        </f7-swiper>
      </div>
    </div>
    <div class="has-content-margin">
      <div
        class="has-content"
        style="text-align: center;"
        v-if="projectList.length === 0">
        暂无数据
      </div>
      <div v-else>
        <div v-for="item in projectList" :key="item.id">
          <div class="project-item">
            <div class="project-content">
              <div class="project-title">
                <div class="project-checkbox" v-if="editable">
                  <f7-checkbox
                    :value="item.id"
                    :checked="checkedList.indexOf(`${item.id}`) >= 0"
                    @change="checkedProject">
                  </f7-checkbox>
                </div>
                <div class="project-checkbox" v-else>&nbsp;</div>
                <f7-link
                  style="display: flex; align-items: flex-start;"
                  :href="`/project/info/${item.id}?rootId=${item.id}`">
                  <span>{{ item.name }}</span>
                  <span style="line-height: 1.4rem;">
                    <img
                    src="@/assets/img/fuzhu.png"
                    class="fuzhu-img"
                    v-if="item.type === 'assistProject'" />
                  </span>
                </f7-link>
              </div>
              <div style="display: flex;" v-if="(item.path || []).length > 0">
                <div class="project-scope-icon">
                  <div @click="item.scopeDisplay=!item.scopeDisplay">
                    <f7-icon
                      :material="item.scopeDisplay?'arrow_drop_up':'arrow_drop_down'">
                    </f7-icon>
                  </div>
                </div>
                <div class="project-scope">
                  <div
                    v-for="(scopeItem, index) in (item.path || [])"
                    :key="item.id+scopeItem"
                    v-show="item.scopeDisplay
                      || (index === (item.path || []).length - 1)">
                    |&nbsp;&nbsp;{{ scopeItem }}
                  </div>
                </div>
                <div style="flex: auto;"></div>
              </div>
              <div class="project-sub-wrap">
                <div class="project-date">
                  {{ item.startupTime | formatDateValue }}
                    至
                  {{ item.completedTime | formatDateValue }}
                </div>
                <div class="project-status-assign" v-if="item.projectStatus === '10'">
                  {{ item.projectStatusDesc }}
                </div>
                <div class="project-status-releasing" v-if="item.projectStatus === '20'">
                  {{ item.projectStatusDesc }}
                </div>
                <div class="project-status-assigned" v-if="item.projectStatus === '30'">
                  {{ item.projectStatusDesc }}
                </div>
                <div class="project-status-working" v-if="item.projectStatus === '40'">
                  {{ item.projectStatusDesc }}
                </div>
                <div class="project-status-checking" v-if="item.projectStatus === '50'">
                  {{ item.projectStatusDesc }}
                </div>
                <div class="project-status-checked" v-if="item.projectStatus === '60'">
                  {{ item.projectStatusDesc }}
                </div>
                <div class="project-msg">
                  <f7-link :href="`/project/msgList/${item.id}?title=通知-${item.name}`">
                    <f7-icon size="1.35rem" icon="cicon-tongzhi" class="project-msg-icon">
                      <f7-badge color="red" v-if="item.unReadMsgNum > 0">
                        {{ item.unReadMsgNum }}
                      </f7-badge>
                    </f7-icon>
                  </f7-link>
                </div>
              </div>
            </div>
            <div class="project-share">
              <f7-link
                :href="`/project/tree/${item.id}?title=${item.name}`">
                <div class="project-share-text">
                  <f7-icon size="2.5em" icon="cicon-chaifen1"></f7-icon>
                  <br/>
                  <div style="font-size: 0.8rem;">下级</div>
                </div>
              </f7-link>
            </div>
          </div>
          <div class="project-footer" :key="item.id">
            <div class="project-footer-row">
              <f7-link @click="showFlag(item)">
                <f7-icon size="1rem" icon="cicon-renwu" class="icon-flag"></f7-icon>
                <span class="icon-text">
                  {{ item.completedChildNum || 0 }}/{{ item.childNum || 0 }}个
                </span>
              </f7-link>
              <div class="line-vertical">&nbsp;</div>
              <f7-link @click="showTeam(item)">
                <f7-icon size="1rem" icon="cicon-renyuan" class="icon-user"></f7-icon>
                <span class="icon-text">
                  {{ item.companyNum || 0 }}队|{{ item.clockInNum || 0 }}人
                </span>
              </f7-link>
              <div class="line-vertical">&nbsp;</div>
              <f7-link @click="showComment(item)">
                <f7-icon size="1rem" icon="cicon-xiaoxi" class="icon-comments">
                  <f7-badge
                    color="red"
                    class="point-badge"
                    style="
                      line-height: 8px;
                      height: 8px;
                      border-radius: 8px;
                      padding: 0 0px;
                      min-width: 8px;
                      font-size: 8px;
                      margin-left: -8px;"
                    v-if="(item.parentId && getUnreadMsg(item.parentId) > 0)
                      || getUnreadMsg(item.id) > 0">
                  </f7-badge>
                </f7-icon>
                <span class="icon-text">
                  工作群
                </span>
              </f7-link>
            </div>
            <div>
              <transition name="slide" mode="out-in" appear>
                <div v-if="item.flagsDisplay" :key="item.id+'flag'">
                  <div class="task-expand-icon">
                    <f7-icon icon="cicon-zhankai1" size="0.8rem"></f7-icon>
                  </div>
                  <f7-swiper
                    class="swiper-info"
                    :params="{speed: 300, slidesPerView: 3, spaceBetween: 20,
                      observer: true, observeParents: true}"
                    v-if="item.childList && item.childList.length > 0">
                    <div slot="before-wrapper" class="swiper-line"></div>
                    <f7-swiper-slide v-for="flag in item.childList" :key="item.id+flag.date">
                      <div class="swiper-slide-info">
                        <div>{{ flag.completedTime | formatDateValue  }}</div>
                        <div :class="
                              flag.completedTime > new Date().getTime() ?
                              '' : 'swiper-timeline-icon'">
                          <f7-icon fa="circle" size="1.5em">
                          </f7-icon>
                        </div>
                        <div v-for="base in flag.childBasics" :key="base.id">{{ base.name }}</div>
                      </div>
                    </f7-swiper-slide>
                  </f7-swiper>
                  <div
                    class="swiper-no-data"
                    v-if="!item.childList || item.childList.length === 0">
                    暂无数据
                  </div>
                </div>
                <div v-if="item.teamsDisplay" :key="item.id+'team'">
                  <div class="team-expand-icon">
                    <f7-icon icon="cicon-zhankai1" size="0.8rem"></f7-icon>
                  </div>
                  <f7-swiper
                    class="swiper-info"
                    :params="{speed: 300, slidesPerView: 3, spaceBetween: 20,
                      observer: true, observeParents: true}"
                    v-if="item.companyList && item.companyList.length > 0">
                    <f7-swiper-slide v-for="team in item.companyList" :key="item.id+team.name">
                      <div class="swiper-slide-info">
                        <f7-icon fa="group" size="2em">
                          <f7-badge color="red">{{ team.number }}</f7-badge>
                        </f7-icon>
                        <div>{{ team.name }}</div>
                      </div>
                    </f7-swiper-slide>
                  </f7-swiper>
                  <div
                    class="swiper-no-data"
                    v-if="!item.companyList || item.companyList.length === 0">
                    暂无数据
                  </div>
                </div>
                <div v-if="item.commentsDisplay" :key="item.id+'comments'">
                  <div class="comments-expand-icon">
                    <f7-icon icon="cicon-zhankai1" size="0.8rem"></f7-icon>
                  </div>
                  <f7-swiper
                    class="swiper-info"
                    :params="{speed: 300, slidesPerView: 2, spaceBetween: 20,
                      observer: true, observeParents: true}">
                    <f7-swiper-slide v-if="item.parentId">
                      <f7-link @click="callGroupChat(item.parentId)">
                        <div class="swiper-slide-info">
                          <f7-icon icon="cicon-qunjiaoliu1" size="2em">
                            <f7-badge color="red" v-if="getUnreadMsg(item.parentId) > 0">
                              {{ getUnreadMsg(item.parentId) }}
                            </f7-badge>
                          </f7-icon>
                          <div>上级工作群</div>
                        </div>
                      </f7-link>
                    </f7-swiper-slide>
                    <f7-swiper-slide v-if="item.id">
                      <f7-link @click="callGroupChat(item.id)">
                        <div class="swiper-slide-info">
                          <f7-icon icon="cicon-qunjiaoliu1" size="2em">
                            <f7-badge color="red" v-if="getUnreadMsg(item.id) > 0">
                              {{ getUnreadMsg(item.id) }}
                            </f7-badge>
                          </f7-icon>
                          <div>当前工作群</div>
                        </div>
                      </f7-link>
                    </f7-swiper-slide>
                  </f7-swiper>
                </div>
              </transition>
            </div>
          </div>
          <div class="project-space"></div>
        </div>
      </div>
    </div>
    <f7-toolbar v-if="editable" style="height: 70px;">
      <div class="project-toolbar-op">
        <div style="display: flex; align-items: center; padding: 0.3rem 0rem;">
          <div class="project-checkbox">
            <f7-checkbox
              value="all"
              :checked="checkedList.length == projectList.length"
              @change="checkedAll">
            </f7-checkbox>
          </div>
          <div>
            全选 {{ checkedList.length }}/{{ projectList.length }}
          </div>
        </div>
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div>
            <f7-segmented raised tag="div">
              <f7-button active @click="addTop">置顶</f7-button>
              <f7-button @click="cancelTop">取消</f7-button>
            </f7-segmented>
          </div>
          <f7-button fill @click="merge">合并任务</f7-button>
          <f7-button @click="delProject">批量删除</f7-button>
        </div>
      </div>
    </f7-toolbar>
    <f7-fab position="right-bottom" slot="fixed" @click="forwardAdd">
      <f7-icon icon="add" style="width: 3rem; text-align: center;">
        <div style="font-size: 0.9rem;">创建<br/>项目</div>
      </f7-icon>
    </f7-fab>
    <div style="height: 5rem;"></div>
    <f7-popup :opened="projectPopupOpened" @popup:closed="projectPopupOpened = false">
      <log-project-list
        :opened="projectPopupOpened"
        :project.sync="project"
        :independent="true">
      </log-project-list>
    </f7-popup>
  </f7-page>
</template>

<script>
import lodash from 'lodash';
import { toConversation, toAttendance, toGroupConversation, getUnreadMsgCount } from '@/util/native';
import { createToast } from '@/util/compUtils';
import { dateFormat } from '@/util/dateUtils';
import { getProjectList, getMsgCount, mergeProject, deleteProject, addTopProject, cancelTopProject } from '@/api/project/project';
import { getComanyList } from '@/api/team/worker';
import LogProjectList from '@/components/LogProjectList';

export default {
  components: {
    LogProjectList,
  },
  data() {
    return {
      editable: false,
      toolOpt: true,
      name: '',
      checkedList: [],
      projectList: [],
      project: {
        id: '',
        name: '',
        date: dateFormat(new Date()),
      },
      msgStatus: {},
      projectPopupOpened: false,
    };
  },
  created() {
    this.debouncedGetList = lodash.debounce(this.getList, 500);
  },
  mounted() {
    this.getList();
    this.$f7.searchbar.create({
      customSearch: true,
      el: '#searchbar-home',
    });
  },
  watch: {
    name() {
      this.debouncedGetList();
    },
  },
  filters: {
    formatDateValue: value => dateFormat(value),
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getList()]).then(() => done());
    },
    searchProjectList(event) {
      this.name = event.detail;
    },
    callWorkMsg() {
      toConversation();
    },
    callAttendance() {
      toAttendance('');
    },
    callGroupChat(id) {
      toGroupConversation(id);
    },
    getUnreadMsg(id) {
      try {
        const param = {};
        this.$set(param, `${id}`, 0);
        const resObj = getUnreadMsgCount(JSON.stringify(param));
        return Number.parseInt(resObj[`${id}`], 10);
      } catch (ex) {
        return 0;
      }
    },
    getList() {
      getProjectList({ name: this.name }).then((result) => {
        if (result.code === 0) {
          this.projectList = (result.data || []).map(item => Object.assign(item, {
            scopeDisplay: false,
            flagsDisplay: false,
            teamsDisplay: false,
            commentsDisplay: false,
          }));
        }
      });
      getMsgCount().then((result) => {
        if (result.code === 0) {
          this.msgStatus = result.data || {};
        }
      });
    },
    editableList() {
      this.editable = !this.editable;
      this.checkedList = [];
    },
    checkedProject(event) {
      const value = event.target.value;
      if (event.target.checked) {
        this.checkedList.push(value);
      } else {
        this.checkedList.splice(this.checkedList.indexOf(value), 1);
      }
    },
    checkedAll(event) {
      if (event.target.checked) {
        this.checkedList = this.projectList.map(item => item.id);
      } else {
        this.checkedList = [];
      }
    },
    addTop() {
      const count = this.checkedList.length;
      if (count === 0) {
        createToast(this, '请选择任务！');
      } else {
        this.$f7.dialog.confirm('确认置顶任务吗？', '温馨提示', () => {
          addTopProject({ ids: this.checkedList }).then((result) => {
            if (result.code === 0) {
              createToast(this, '置顶成功！');
              this.checkedList = [];
              this.getList();
            }
          });
        });
      }
    },
    cancelTop() {
      const count = this.checkedList.length;
      if (count === 0) {
        createToast(this, '请选择任务！');
      } else {
        this.$f7.dialog.confirm('确认取消置顶任务吗？', '温馨提示', () => {
          cancelTopProject({ ids: this.checkedList }).then((result) => {
            if (result.code === 0) {
              createToast(this, '取消置顶成功！');
              this.checkedList = [];
              this.getList();
            }
          });
        });
      }
    },
    merge() {
      const count = this.checkedList.length;
      if (count !== 2) {
        createToast(this, '合并需要选择2个任务！');
      } else {
        this.$f7.dialog.confirm('确认要合并任务吗？', '温馨提示', () => {
          mergeProject({ ids: this.checkedList }).then((result) => {
            if (result.code === 0) {
              createToast(this, '合并成功！');
              this.checkedList = [];
              this.getList();
            }
          });
        });
      }
    },
    delProject() {
      const count = this.checkedList.length;
      if (count === 0) {
        createToast(this, '请选择任务！');
      } else {
        this.$f7.dialog.confirm('删除后不可恢复，确认要删除任务吗？', () => {
          deleteProject({ ids: this.checkedList }).then((result) => {
            if (result.code === 0) {
              createToast(this, '删除成功！');
              this.checkedList = [];
              this.getList();
            }
          });
        });
      }
    },
    forwardAdd() {
      getComanyList().then((result) => {
        if (result.code === 0) {
          if (lodash.isEmpty(result.data)) {
            createToast(this, '亲，您需要先到“我的-创建队伍”功能，创建自己的队伍并设置队伍负责人');
          } else {
            this.$f7router.navigate('/project/add?title=创建项目');
          }
        } else {
          createToast(this, '亲，您需要先到“我的-创建队伍”功能，创建自己的队伍并设置队伍负责人');
        }
      });
    },
    showFlag(item) {
      this.$set(item, 'flagsDisplay', !item.flagsDisplay);
      this.$set(item, 'teamsDisplay', false);
      this.$set(item, 'commentsDisplay', false);
    },
    showTeam(item) {
      this.$set(item, 'flagsDisplay', false);
      this.$set(item, 'teamsDisplay', !item.teamsDisplay);
      this.$set(item, 'commentsDisplay', false);
    },
    showComment(item) {
      this.$set(item, 'flagsDisplay', false);
      this.$set(item, 'teamsDisplay', false);
      this.$set(item, 'commentsDisplay', !item.commentsDisplay);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .navbar-menu {
    padding-left: 0rem;
    color: #ffffff;
    font-size: 1.5rem;
  }

  .searchbar-home {
    background-color: $theme-color;
  }

  .searchbar-button-home {
    color: $white-color;
    font-weight: 500;
  }

  .quick-menu {
    background-color: $white-color;
    padding-bottom: 0.3rem;
    border-radius: 0.3rem;
  }

  .quick-menu-link {
    text-align: center;
  }

  .quick-menu-text {
    margin-top: -0.5rem;
  }

  .project-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 0.5rem;
  }

  .project-title {
    font-size: 1rem;
    display: flex;
  }

  .project-checkbox {
    width: 1.85rem;
    min-width: 1.85rem;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .fuzhu-img {
    padding: 0.1rem 0.5rem 0.1rem 0rem;
    width: 1.2rem;
    height: 1.2rem;
  }

  .project-share {
    border-left: 0.05rem solid $border-color;
    padding: 0rem 0.5rem;
    margin-top: -1rem;
    color: $theme-color;
    font-size: 0.6rem;
    text-align: center;
    min-width: 2.5rem;
    width: 2.5rem;
  }

  .project-share-text {
    color: $theme-color;
    font-size: 0.6rem;
    width: 2rem;
  }

  .project-scope-icon {
    width: 1.85rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #D3D3D3;
    cursor: pointer;
  }

  .project-scope {
    border: 0.05rem dashed #D3D3D3;
    margin-left: 0rem;
    padding-left: 0.5rem;
    width: 12rem;
    color: #333333;
    font-size: 0.6rem;
  }

  .project-scope > div {
    padding: 0.2rem;
  }

  .project-space {
    background-color: $bg-color;
    height: 0.5rem;
  }

  .project-footer {
    padding-top: 0.5rem;
    text-align: center;
    border-bottom: 0.05rem solid $border-color;
    background-color: #FCFCFC;
  }

  .project-footer-row {
    padding-left: 1.85rem;
    padding-right: 1.85rem;
    padding-bottom: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .project-footer .icon-flag {
    color: $theme-color;
  }

  .project-footer .icon-user {
    color: $theme-color;
  }

  .project-footer .icon-comments {
    color: $theme-color;
  }

  .project-footer .icon-text {
    font-size: 0.8rem;
  }

  .swiper-info {
    text-align: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    background-color: #535353;
    font-size: 0.8rem;
  }

  .swiper-slide-info {
    color: $white-color;
  }

  .swiper-line {
    position: absolute;
    left: 1%;
    top: 2.1rem;
    border-top: 0.3rem solid #8C8C8C;
    z-index: 1;
    height: 0.5em;
    width: 98%;
  }

  .swiper-timeline-icon {
    color: $theme-color;
  }

  .swiper-left-title {
    width: 2rem;
    border-right: 0.1rem dashed #98FB98;
  }

  .swiper-center-v {
    display:flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-no-data {
    text-align: center;
    width: 100%;
    font-size: 0.8rem;
    background-color: #535353;
    height: 1.5rem;
    line-height: 1.5rem;
    color: $white-color;
  }

  .project-sub-wrap {
    padding: 0.3rem 0rem;
    display: flex;
    align-items: center;
  }

  .project-date {
    font-size: 0.8rem;
    display: flex;
    align-items:Center;
    padding-left: 1.85rem;
    padding-right: 0.5rem;
    color: $second-font-color;
  }

  @mixin project-status($color) {
    padding: 0rem 0.05rem;
    border: 0.08rem solid $color;
    border-radius: 0.3rem;
    width: 2.5rem;
    min-width: 2.5rem;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    font-size: 0.7rem;
    font-weight: 500;
    color: $color;
  }

  .project-status-assign {
    @include project-status(#f7ad3a);
  }

  .project-status-releasing {
    @include project-status(#8957a1);
  }

  .project-status-assigned {
    @include project-status(#008be6);
  }

  .project-status-working {
    @include project-status(#bb9e76);
  }
  .project-status-checking {
    @include project-status(#cf5152);
  }

  .project-status-checked {
    @include project-status(#5fad2f);
  }

  .project-msg {
    font-size: 0.6rem;
    display: flex;
    align-items:Center;
    padding-left: 0.5rem;
  }

  .project-msg-icon {
    color: $second-color;
  }

  .task-expand-icon {
    color: #535353;
    text-align: left;
    padding-left: 4rem;
    margin-top: -0.5rem;
    margin-bottom: -0.2rem;
    line-height: 0.8rem;
  }

  .team-expand-icon {
    color: #535353;
    width: 100%;
    text-align: center;
    margin-top: -0.5rem;
    margin-bottom: -0.2rem;
    line-height: 0.8rem;
  }

  .comments-expand-icon {
    text-align: right;
    padding-right: 4rem;
    color: #535353;
    margin-top: -0.5rem;
    margin-bottom: -0.2rem;
    line-height: 0.8rem;
  }

  .point-badge {
    line-height: 8px;
    height: 8px;
    border-radius: 8px;
    padding: 0 0px;
    min-width: 8px;
    font-size: 8px;
    margin-left: -8px;
  }

  .project-toolbar-op {
    width: 100%;
    padding-right: 1.85rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/project/home.vue